// WF一覧動作
export enum WorkflowListActionKinds {
  EditDetail = 0, // 依頼編集
  EditDocument = 1, // 文書編集
}
